import { createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dd76097"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 h-100" }
const _hoisted_2 = {
  style: {"margin-left":"1%"},
  id: "msgdiv"
}
const _hoisted_3 = { id: "divMainMaintenance" }
const _hoisted_4 = { id: "divSelectMaintenaceType" }
const _hoisted_5 = { id: "divRdoService" }
const _hoisted_6 = ["checked"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-left-tech-20" }, "Service", -1 /* HOISTED */))
const _hoisted_8 = { id: "divRdoCategory" }
const _hoisted_9 = ["checked"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-left-tech-20" }, "Service Category", -1 /* HOISTED */))
const _hoisted_11 = { id: "divRdoDocument" }
const _hoisted_12 = ["checked"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-left-tech-20" }, "Technical Document", -1 /* HOISTED */))
const _hoisted_14 = {
  key: 0,
  id: "divServiceMaintenace"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "divEditServiceTitle" }, "Service Specification Maintenance", -1 /* HOISTED */))
const _hoisted_16 = { id: "divEditServiceList" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "divEditHeaderServiceSpecificationDetail" }, [
  /*#__PURE__*/_createElementVNode("table", { id: "tblEditHeaderServiceSpecificationDetail" }, [
    /*#__PURE__*/_createElementVNode("thead", null, [
      /*#__PURE__*/_createElementVNode("th", null, "Service"),
      /*#__PURE__*/_createElementVNode("th", null, "Specification Details"),
      /*#__PURE__*/_createElementVNode("th"),
      /*#__PURE__*/_createElementVNode("th")
    ])
  ])
], -1 /* HOISTED */))
const _hoisted_18 = { id: "divEditServiceSpecificationDetail" }
const _hoisted_19 = { id: "tblEditServiceSpecificationDetail" }
const _hoisted_20 = ["value"]
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { id: "divCategoryMaintenace" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "divEditCategoryTitle" }, "Service Category Maintenance", -1 /* HOISTED */))
const _hoisted_26 = { id: "divEditCategoryList" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "divEditHeaderCategoryDetail" }, [
  /*#__PURE__*/_createElementVNode("table", { id: "tblEditHeaderCategoryDetail" }, [
    /*#__PURE__*/_createElementVNode("thead", null, [
      /*#__PURE__*/_createElementVNode("th", null, "Category"),
      /*#__PURE__*/_createElementVNode("th", null, "Specification Upload"),
      /*#__PURE__*/_createElementVNode("th", null, "Main Menu"),
      /*#__PURE__*/_createElementVNode("th", null, "Showing Flag"),
      /*#__PURE__*/_createElementVNode("th"),
      /*#__PURE__*/_createElementVNode("th")
    ])
  ])
], -1 /* HOISTED */))
const _hoisted_28 = { id: "divEditCategoryDetail" }
const _hoisted_29 = { id: "tblEditCategoryDetail" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "parent-btn-txt-hid-container" }
const _hoisted_32 = ["value"]
const _hoisted_33 = ["checked"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */))
const _hoisted_35 = ["id", "value"]
const _hoisted_36 = { class: "parent-btn-txt-hid-container" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["id", "value"]
const _hoisted_39 = ["id"]
const _hoisted_40 = ["id", "onChange"]
const _hoisted_41 = ["value", "selected"]
const _hoisted_42 = ["checked", "onUpdate:modelValue"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { id: "divDocumentMaintenance" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "divEditDocumentTitle" }, "Technical Document Maintenance", -1 /* HOISTED */))
const _hoisted_47 = { id: "divEditDocumentList" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "divEditHeaderDocumentDetail" }, [
  /*#__PURE__*/_createElementVNode("table", { id: "tblEditHeaderDocumentDetail" }, [
    /*#__PURE__*/_createElementVNode("thead", null, [
      /*#__PURE__*/_createElementVNode("th", null, "Document Upload"),
      /*#__PURE__*/_createElementVNode("th", null, "Document Name"),
      /*#__PURE__*/_createElementVNode("th", null, "Main Menu"),
      /*#__PURE__*/_createElementVNode("th", null, "Category"),
      /*#__PURE__*/_createElementVNode("th", null, "Showing Flag"),
      /*#__PURE__*/_createElementVNode("th"),
      /*#__PURE__*/_createElementVNode("th")
    ])
  ])
], -1 /* HOISTED */))
const _hoisted_49 = { id: "divEditDocumentDetail" }
const _hoisted_50 = { id: "tblEditDocumentDetail" }
const _hoisted_51 = { class: "parent-btn-txt-hid-container" }
const _hoisted_52 = ["value"]
const _hoisted_53 = ["value"]
const _hoisted_54 = ["checked"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */))
const _hoisted_56 = { class: "parent-btn-txt-hid-container" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = ["id", "value"]
const _hoisted_59 = ["id"]
const _hoisted_60 = ["id", "onUpdate:modelValue"]
const _hoisted_61 = ["id", "onChange"]
const _hoisted_62 = ["value", "v-model", "selected"]
const _hoisted_63 = ["id", "onUpdate:modelValue"]
const _hoisted_64 = ["selected", "value"]
const _hoisted_65 = ["checked", "onUpdate:modelValue"]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    _createVNode($setup["AdminNavigation"], { menuTile: $setup.title }, null, 8 /* PROPS */, ["menuTile"]),
    _createElementVNode("div", _hoisted_3, [
      _createCommentVNode(" Maintenance Choice "),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("input", {
            type: "radio",
            id: "rdoService",
            onChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.rdoCheckChange($event))),
            value: "Service Maintenance",
            checked: $setup.radioCheck == 'Service Maintenance'
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_6),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("input", {
            type: "radio",
            id: "rdoCategory",
            onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.rdoCheckChange($event))),
            value: "Category Maintenance",
            checked: $setup.radioCheck == 'Category Maintenance'
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_9),
          _hoisted_10
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("input", {
            type: "radio",
            id: "rdoDocument",
            onChange: _cache[2] || (_cache[2] = ($event: any) => ($setup.rdoCheckChange($event))),
            value: "Document Maintenance",
            checked: $setup.radioCheck == 'Document Maintenance'
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_12),
          _hoisted_13
        ])
      ]),
      _createCommentVNode(" Service Maintenance "),
      ($setup.radioCheck == 'Service Maintenance')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("table", _hoisted_19, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lstService[0], (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("input", {
                            type: "text",
                            id: "txtService",
                            class: "techTxt",
                            disabled: "",
                            value: item.mainMenuName
                          }, null, 8 /* PROPS */, _hoisted_20)
                        ]),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("textarea", {
                            id: "txtSpecificationInput",
                            maxlength: "1000",
                            class: "txtSpecificationInput",
                            "onUpdate:modelValue": ($event: any) => ((item.specification) = $event)
                          }, null, 8 /* PROPS */, _hoisted_21), [
                            [_vModelText, item.specification]
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            id: "btnServiceUpdate",
                            class: "techProcessBtn",
                            onClick: ($event: any) => ($setup.updateOrClearSpecification('Update', index))
                          }, "Update", 8 /* PROPS */, _hoisted_22)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            id: "btnServiceClear",
                            class: "techProcessBtn",
                            onClick: ($event: any) => ($setup.updateOrClearSpecification('Clear', index))
                          }, "Clear", 8 /* PROPS */, _hoisted_23)
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ])
            ])
          ]))
        : ($setup.radioCheck == 'Category Maintenance')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode(" Category Maintenance "),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("table", _hoisted_29, [
                      _createElementVNode("tbody", null, [
                        (!$setup.isLoading || $setup.lstCategory.length != 0)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: _normalizeClass(["techTxt", { 'techErrorBox': $setup.boolAddC_DescriptionError }]),
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.addCategoryDescription) = $event))
                                }, null, 2 /* CLASS */), [
                                  [_vModelText, $setup.addCategoryDescription]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("button", {
                                    id: "btnAddCategory",
                                    class: "techUploadBtn",
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.uploadClick($event)))
                                  }, "Browse"),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: _normalizeClass(["techTxt w-techTxt", { 'techErrorBox': $setup.boolAddC_FileNameError }]),
                                    readonly: "",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.addCategoryFileName) = $event))
                                  }, null, 2 /* CLASS */), [
                                    [_vModelText, $setup.addCategoryFileName]
                                  ]),
                                  _createElementVNode("input", {
                                    type: "file",
                                    id: "updCategory",
                                    class: "d-none-tech",
                                    onChange: _cache[6] || (_cache[6] = ($event: any) => ($setup.selectFile($event)))
                                  }, null, 32 /* HYDRATE_EVENTS */)
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("select", {
                                  class: _normalizeClass(["form-select menu-form-select", { 'techErrorBox': $setup.boolAddC_MenuError }]),
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.addCategoryMenu) = $event))
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lstCategoryMenu[0], (info, index) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      class: "adjusting-option",
                                      key: index,
                                      value: info.mainMenuCode
                                    }, _toDisplayString(info.mainMenuCode) + " (" + _toDisplayString(info.mainMenuName) + ") ", 9 /* TEXT, PROPS */, _hoisted_32))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ], 2 /* CLASS */), [
                                  [_vModelSelect, $setup.addCategoryMenu]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  id: "rowChkIsShowing",
                                  checked: $setup.addCategoryShowFlg,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.addCategoryShowFlg) = $event))
                                }, null, 8 /* PROPS */, _hoisted_33), [
                                  [_vModelCheckbox, $setup.addCategoryShowFlg]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("button", {
                                  class: "techProcessBtn",
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.addOrUpdateTechnicalCategory('Add')))
                                }, "Add")
                              ]),
                              _hoisted_34
                            ]))
                          : _createCommentVNode("v-if", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lstCategory[0], (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, [
                              _createElementVNode("input", {
                                type: "text",
                                id: 'txtC_Description' + index,
                                class: "techTxt",
                                value: item.description
                              }, null, 8 /* PROPS */, _hoisted_35)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("button", {
                                  id: "btnRowAddCategory",
                                  class: "techUploadBtn",
                                  onClick: ($event: any) => ($setup.uploadClick($event, index))
                                }, "Browse", 8 /* PROPS */, _hoisted_37),
                                _createElementVNode("input", {
                                  type: "text",
                                  id: 'txtUpdC_file' + index,
                                  value: item.fileName,
                                  readonly: "",
                                  class: "techTxt w-techTxt"
                                }, null, 8 /* PROPS */, _hoisted_38),
                                _createElementVNode("input", {
                                  type: "file",
                                  id: 'updRowAddCategory' + index,
                                  class: "d-none-tech",
                                  onChange: _cache[10] || (_cache[10] = ($event: any) => ($setup.selectFile($event)))
                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_39)
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("select", {
                                id: 'ddlMainMenu' + index,
                                onChange: ($event: any) => ($setup.categoryMenuChange($event, index)),
                                class: "form-select menu-form-select"
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lstCategoryMenu[0], (info, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    class: "adjusting-option",
                                    key: index,
                                    value: info.mainMenuCode,
                                    selected: info.mainMenuCode == item.mainMenuCode_id
                                  }, _toDisplayString(info.mainMenuCode) + " (" + _toDisplayString(info.mainMenuName) + ") ", 9 /* TEXT, PROPS */, _hoisted_41))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_40)
                            ]),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                id: "rowChkIsShowing",
                                checked: item.isShowing,
                                "onUpdate:modelValue": ($event: any) => ((item.isShowing) = $event)
                              }, null, 8 /* PROPS */, _hoisted_42), [
                                [_vModelCheckbox, item.isShowing]
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("button", {
                                class: "techProcessBtn",
                                onClick: ($event: any) => ($setup.addOrUpdateTechnicalCategory('Update', index))
                              }, "Update", 8 /* PROPS */, _hoisted_43)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("button", {
                                class: "techProcessBtn",
                                onClick: ($event: any) => ($setup.addOrUpdateTechnicalCategory('Delete', index))
                              }, "Delete", 8 /* PROPS */, _hoisted_44)
                            ])
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ])
                  ])
                ])
              ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
          : ($setup.radioCheck == 'Document Maintenance')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createCommentVNode(" Technical Document Maintenance "),
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("table", _hoisted_50, [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("button", {
                                  id: "btnAddDocument",
                                  class: "techUploadBtn",
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.uploadClick($event)))
                                }, "Browse"),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: _normalizeClass(["techTxt w-techTxt", { 'techErrorBox': $setup.boolAddD_FileNameError }]),
                                  readonly: "",
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.addDocumentFileName) = $event))
                                }, null, 2 /* CLASS */), [
                                  [_vModelText, $setup.addDocumentFileName]
                                ]),
                                _createElementVNode("input", {
                                  type: "file",
                                  id: "updDocument",
                                  class: "d-none-tech",
                                  onChange: _cache[13] || (_cache[13] = ($event: any) => ($setup.selectFile($event)))
                                }, null, 32 /* HYDRATE_EVENTS */)
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["techTxt", { 'techErrorBox': $setup.boolAddD_NameError }]),
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.addDocumentName) = $event))
                              }, null, 2 /* CLASS */), [
                                [_vModelText, $setup.addDocumentName]
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("select", {
                                class: "form-select menu-form-select",
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.addDocumentCategoryMenu) = $event)),
                                onChange: _cache[16] || (_cache[16] = ($event: any) => ($setup.getCategoryByMenu($event)))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lstCategoryMenu[0], (info, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    class: "adjusting-option",
                                    key: index,
                                    value: info.mainMenuCode
                                  }, _toDisplayString(info.mainMenuCode) + ": (" + _toDisplayString(info.mainMenuName) + ") ", 9 /* TEXT, PROPS */, _hoisted_52))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                [_vModelSelect, $setup.addDocumentCategoryMenu]
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.addDocumentCategory) = $event)),
                                class: _normalizeClass([{ 'techErrorBox': $setup.boolAddD_CategoryError }, "form-select menu-form-select"])
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lstUniqueCategory, (info, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    class: "adjusting-option",
                                    key: index,
                                    value: info.categoryId
                                  }, _toDisplayString(info.categoryId) + ": (" + _toDisplayString(info.description) + ") ", 9 /* TEXT, PROPS */, _hoisted_53))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 2 /* CLASS */), [
                                [_vModelSelect, $setup.addDocumentCategory]
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                id: "rowChkDocumentIsShowing",
                                checked: $setup.addDocumentShowFlg,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.addDocumentShowFlg) = $event))
                              }, null, 8 /* PROPS */, _hoisted_54), [
                                [_vModelCheckbox, $setup.addDocumentShowFlg]
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("button", {
                                class: "techProcessBtn",
                                onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.addOrUpdateTechnicalDocument('Add')))
                              }, "Add")
                            ]),
                            _hoisted_55
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lstDocument[0], (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_56, [
                                  _createElementVNode("button", {
                                    id: "btnRowAddDocument",
                                    class: "techUploadBtn",
                                    onClick: ($event: any) => ($setup.uploadClick($event, index))
                                  }, "Browse", 8 /* PROPS */, _hoisted_57),
                                  _createElementVNode("input", {
                                    type: "text",
                                    id: 'txtUpdD_file' + index,
                                    value: item.fileName,
                                    readonly: "",
                                    class: "techTxt w-techTxt"
                                  }, null, 8 /* PROPS */, _hoisted_58),
                                  _createElementVNode("input", {
                                    type: "file",
                                    id: 'updRowAddDocument' + index,
                                    class: "d-none-tech",
                                    onChange: _cache[20] || (_cache[20] = ($event: any) => ($setup.selectFile($event)))
                                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_59)
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  id: 'txtD_Name' + index,
                                  type: "text",
                                  class: "techTxt",
                                  "onUpdate:modelValue": ($event: any) => ((item.documentName) = $event)
                                }, null, 8 /* PROPS */, _hoisted_60), [
                                  [_vModelText, item.documentName]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("select", {
                                  id: 'ddlD_MainMenu' + index,
                                  class: "form-select menu-form-select",
                                  onChange: ($event: any) => ($setup.getCategoryByMenu($event, index))
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lstCategoryMenu[0], (mInfo, index) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      class: "adjusting-option",
                                      key: index,
                                      value: mInfo.mainMenuCode,
                                      "v-model": mInfo.mainMenuCode,
                                      selected: mInfo.mainMenuCode == item.mainMenuCode_id
                                    }, _toDisplayString(mInfo.mainMenuCode) + " (" + _toDisplayString(mInfo.mainMenuName) + ") ", 9 /* TEXT, PROPS */, _hoisted_62))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_61)
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("select", {
                                  id: 'ddlD_Category' + index,
                                  class: "form-select menu-form-select",
                                  "onUpdate:modelValue": ($event: any) => ((item.categoryId_id) = $event)
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lstUniqueAllCategory, (info, index) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                      (info.mainMenuCode == item.mainMenuCode_id)
                                        ? (_openBlock(), _createElementBlock("option", {
                                            key: 0,
                                            class: "adjusting-option",
                                            selected: item.categoryId_id,
                                            value: info.categoryId
                                          }, _toDisplayString(info.categoryId) + ": (" + _toDisplayString(info.description) + ") ", 9 /* TEXT, PROPS */, _hoisted_64))
                                        : _createCommentVNode("v-if", true)
                                    ], 64 /* STABLE_FRAGMENT */))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ], 8 /* PROPS */, _hoisted_63), [
                                  [_vModelSelect, item.categoryId_id]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  id: "rowChkDocumentIsShowing",
                                  checked: item.isShowing,
                                  "onUpdate:modelValue": ($event: any) => ((item.isShowing) = $event)
                                }, null, 8 /* PROPS */, _hoisted_65), [
                                  [_vModelCheckbox, item.isShowing]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("button", {
                                  class: "techProcessBtn",
                                  onClick: ($event: any) => ($setup.addOrUpdateTechnicalDocument('Update', index))
                                }, "Update", 8 /* PROPS */, _hoisted_66)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("button", {
                                  class: "techProcessBtn",
                                  onClick: ($event: any) => ($setup.addOrUpdateTechnicalDocument('Delete', index))
                                }, "Delete", 8 /* PROPS */, _hoisted_67)
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ])
                    ])
                  ])
                ])
              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
            : _createCommentVNode("v-if", true)
    ])
  ]))
}